import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of } from "rxjs";
import { AppSettings } from "./AppSettings";

@Injectable({
  providedIn: 'root',
})

export class ApiService {
  private loadAPIcallValueSubject = new BehaviorSubject<boolean>(true);
  loadAPIcallValue$ = this.loadAPIcallValueSubject.asObservable();
  httpHeaders: { headers: HttpHeaders; };
  constructor(
    private http: HttpClient) {
    this.httpHeaders = {
      headers: new HttpHeaders().set('Platform', 'GIGSUMO_APP').set('curl' , "login").set("Accept" , "*"),
    };
  }

  query(u: string, errorMessage?: string): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.get<any>(url, { headers: this.httpHeaders.headers }).pipe(
      catchError(this.handleError<any>(errorMessage)));
  }

  create(u: any, User: any, errorMessage?: string): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.post<any>(url, User, { headers: this.httpHeaders.headers }).pipe(
      catchError(this.handleError<any>(errorMessage))
    )
  }

  startLoader() {
    //   this.spinner.show();
  }

  stopLoader() {
    //   this.spinner.hide();
  }

  getPlanFeatures(url:string): Observable<any> {
    return this.http.get<any>(url);
  }


  errorCount = 0
  public handleError<T>(operation: string | undefined, result?: T) {
    return (error: any): Observable<T> => {
      if (error.status === 500) {
        throw error;
      } else if (error.status === 0) {
        throw error;
      } else if (error.status === 400 || error.status === 401) {
        throw error;
      } else if (error.status === 404 || error.status === 440) {
        throw error;
      } else if (error.status === 303) {
        throw error;
      }
      return of(result as T);
    };
  }

}
